'use client';

import { motion } from 'framer-motion';

export default function ContactSection() {
  return (
    <motion.section
      id="contact"
      className="w-full py-24 sm:py-32"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, amount: 0.5 }}
      transition={{ duration: 0.8 }}
    >
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-4xl font-bold text-white">Let's Connect.</h2>
        <p className="mt-6 text-lg text-text-primary leading-loose">
          I'm currently seeking new opportunities and would love to hear from you. Whether you have a question or just want to say hi, feel free to reach out.
        </p>
        <div className="mt-10">
          <a
            href="mailto:osazeokunboca@gmail.com"
            className="inline-flex items-center gap-2 px-8 py-4 font-semibold text-white bg-brand-accent rounded-md hover:bg-brand-accent-hover transition-colors"
          >
            Get in Touch
          </a>
        </div>
        <div className="flex justify-center gap-8 mt-12">
          <a href="https://www.linkedin.com/in/osazeokunbo" target="_blank" rel="noopener noreferrer" className="text-text-secondary hover:text-white transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-linkedin"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>
          </a>
        </div>
      </div>
    </motion.section>
  );
}